import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../../shared/guards/auth.guards';
import { Groups } from '../security/model/groups.model';
import { CustomerUserComponent } from './components/customer-user/customer-user.component';

export class CustomerUserRoutingStates {
  public static readonly LIST = {
    url: 'customerUser'
  };
}

export const UserRoutes: Routes = [
  {
    path: CustomerUserRoutingStates.LIST.url,
    data: {
      page: {
        title: 'Customer User Management'
      },
      requiresRole: [Groups.CUSTOMER_USER_MANAGER]
    },
    component: CustomerUserComponent,
    canActivate: [AuthGuard]
  }
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forChild(UserRoutes)]
})
export class CustomerUserRoutingModule {}
